const config = {
  apiGateway: {
    REGION: 'ap-southeast-2',
    INTERNAL_API_URL: 'https://798gjmhca0.execute-api.ap-southeast-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://sek32oiyii.execute-api.ap-southeast-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.nsr.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.nsr.forwoodsafety.com',
    WEBSOCKET: 'wss://31o1517wr7.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
};

export default config;
